import React from "react";
import { Link } from "react-router-dom";

const cards = [
  { to: "/financeiro/contas-pagar", title: "Contas a pagar" },
  { to: "/financeiro/contas-receber", title: "Contas a receber" },
  { to: "/financeiro/movimentacoes", title: "Movimentacoes" },
  { to: "/financeiro/transferencias", title: "Transferencias" },
  { to: "/financeiro/fluxo-caixa", title: "Fluxo de caixa" },
  { to: "/financeiro/orcamentos", title: "Orcamentos" },
];

export const FinanceiroHome: React.FC = () => {
  return (
    <div className="container py-4">
      <h1 className="mb-3">Financeiro transacional</h1>
      <p className="text-muted">
        Operacoes com busca digitada, paginacao e conciliacao.
      </p>
      <div className="row g-3">
        {cards.map((card) => (
          <div className="col-md-6 col-lg-4" key={card.to}>
            <div className="card shadow-sm h-100">
              <div className="card-body d-flex flex-column">
                <h5 className="card-title">{card.title}</h5>
                <Link to={card.to} className="btn btn-outline-primary mt-auto">
                  Acessar
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
